import { render, staticRenderFns } from "./staff-charts.vue?vue&type=template&id=2f8f0ec7&scoped=true&"
import script from "./staff-charts.vue?vue&type=script&lang=js&"
export * from "./staff-charts.vue?vue&type=script&lang=js&"
import style0 from "./staff-charts.vue?vue&type=style&index=0&id=2f8f0ec7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f0ec7",
  null
  
)

export default component.exports